const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
};

const parseJSON = (response) => response.json();

const fetchJSON = (url, options) => {
  // perform a cors pre-flight request and return a promise
  return window
    .fetch(url, Object.assign({ mode: 'cors' }, options))
    .then(checkStatus)
    .then(parseJSON)
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error(err.message);
    });
};

export default fetchJSON;
